import React from 'react';
import AnimatedContent from '../AnimatedContent';

const CHECKS = [
  'Status und Studienfach erfasst',
  'Karriere-Ziel definiert',
  'Erwartungen an CVFlow festgelegt',
  'Profil sicher gespeichert',
];

export default function StepAbschluss() {
  return (
    <div className="ob-step-enter">
      <div className="ob-check-list">
        {CHECKS.map((text, i) => (
          <AnimatedContent
            key={i}
            distance={40}
            direction="horizontal"
            reverse={false}
            duration={0.6}
            ease="power3.out"
            initialOpacity={0}
            animateOpacity
            delay={i * 0.15}
            threshold={0.1}
          >
            <div className="ob-check-item">
              <div className="ob-check-icon">✓</div>
              <span className="ob-check-text">{text}</span>
            </div>
          </AnimatedContent>
        ))}
      </div>
      <AnimatedContent
        distance={30}
        direction="vertical"
        duration={0.6}
        ease="power3.out"
        initialOpacity={0}
        animateOpacity
        delay={CHECKS.length * 0.15 + 0.1}
        threshold={0.1}
      >
        <div className="ob-next-steps">
          <div className="ob-next-steps__label">Was als nächstes passiert</div>
          <div className="ob-next-steps__text">
            Im Studio fügst du eine Stellenanzeige ein — wir generieren deinen
            ATS-optimierten Lebenslauf in 60 Sekunden.
          </div>
        </div>
      </AnimatedContent>
    </div>
  );
}
